<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="page-title">
        <h1>{{ page_title }}</h1>
        <div [matTooltip]="clock_status() ? 'Solo podrás solicitar vacaciones cuando fiches salida.' : ''">
          <button mat-flat-button color="accent" (click)="openCreateVacationsDialog()" [disabled]="clock_status()">
            Solicitar vacaciones
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (data() && dataSource) {
    <div class="row row-cards-equal-height">
      <div class="col-12 col-lg-6 col-xl-4">
        <div class="card card-vacaciones-totales">
          <div class="card-body card-vacaciones-totales__body">
            <div class="card-vacaciones-totales__left">
              <p class="card-vacaciones-totales__subtitle">Vacaciones totales</p>
              <h2 class="card-vacaciones-totales__total">
                {{ data()!.vacation_days_breakdown!.total_days | number: '1.0-0' | unlimitedVacationDays }} días
              </h2>
            </div>
            <div class="card-vacaciones-totales__breakdown">
              <span class="card-vacaciones-totales__item"
                ><span class="card-vacaciones-totales__number">{{
                  data()!.vacation_days_breakdown!.agreement_days | number: '1.0-0' | unlimitedVacationDays
                }}</span>
                de convenio</span
              >
              <span class="card-vacaciones-totales__item"
                ><span class="card-vacaciones-totales__number">{{
                  data()!.vacation_days_breakdown!.bisual_extra_days | number: '1.0-0'
                }}</span>
                extra por Bisual</span
              >
              <span class="card-vacaciones-totales__item"
                ><span class="card-vacaciones-totales__number">{{
                  data()!.vacation_days_breakdown!.legal_agreement_maximum_hours_extra_days | number: '1.0-0'
                }}</span>
                no superar h. anuales</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-4">
        <div class="card">
          <div class="card-header" style="margin-bottom: 0">
            <div class="card-title">
              <p class="subtitle">Vacaciones adjudicadas</p>
              <h2>{{ data()!.spent.days | number: '1.0-0' }} días</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-4">
        <div class="card" [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="nobottom">
            <mat-label>Año a visualizar</mat-label>
            <mat-select formControlName="year">
              @for (year of years; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bisual-table">
          <div class="bisual-table-container">
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let item; dataSource: dataSource">{{ item.from_date | date: 'shortDate' }}</td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let item; dataSource: dataSource">
                  @if (isVacationCompleted(item)) {
                    <span class="done">Completado</span>
                  } @else {
                    <span class="accepted">Aceptado</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="year_imputed">
                <th mat-header-cell *matHeaderCellDef>Imputado en el año</th>
                <td mat-cell *matCellDef="let item; dataSource: dataSource">
                  @if (permissions.isAdmin()) {
                    <mat-form-field appearance="outline" class="nobottom">
                      <mat-select [ngModel]="item.year" (ngModelChange)="onYearUpdated(item, $event)">
                        @for (year of years; track year) {
                          <mat-option
                            [value]="year"
                            [disabled]="
                              !(
                                year === dayjs(item.from_date).year() ||
                                (year === dayjs(item.from_date).year() - 1 && dayjs(item.from_date).month() === 0)
                              )
                            "
                          >
                            {{ year }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  } @else {
                    {{ item.year }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let item; dataSource: dataSource">
                  <div [matTooltip]="!canDeleteVacation(item) ? 'No puedes eliminar vacaciones completadas.' : null">
                    <button mat-icon-button color="warn" (click)="deleteVacation(item)" [disabled]="!canDeleteVacation(item)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  }
</div>
